import { PROJECTED_SALE_TYPES } from '../constants';

export default function getEmptyProjectedSale(
  type = PROJECTED_SALE_TYPES.default,
  locationId,
  target
) {
  const template = {
    locationId,
    type,
  };

  if (type === PROJECTED_SALE_TYPES.default) {
    return { ...template, weekday: target };
  }

  return { ...template, date: target };
}
